import React from 'react';

const Alert = () => 
    <svg width='17px' height='13px' viewBox='0 0 17 13' version='1.1'>
        <defs></defs>
        <g id='UI-elements' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd' transform='translate(-288.000000, -2257.000000)'>
            <g id='Alert-Copy' transform='translate(288.000000, 2257.000000)' fill='#DA2946'>
                <g id='Alert'>
                    <path 
                        d='M9.33696961,1.28007117 L15.988337,11.4527506 C16.2905744,11.9149962 16.1608623,12.5347321 15.6986167,12.8369696 C15.5359227,12.9433465 15.345752,13 15.1513673,13 L1.84863266,13 C1.29634791,13 0.848632659,12.5522847 0.848632659,12 C0.848632659,11.8056154 0.905286183,11.6154447 1.01166305,11.4527506 L7.66303039,1.28007117 C7.96526786,0.81782562 8.58500381,0.688113446 9.04724936,0.990350923 C9.16278406,1.06589284 9.2614277,1.16453647 9.33696961,1.28007117 Z M9.09472656,8.74902344 L9.3046875,3.890625 L7.55175781,3.890625 L7.76171875,8.74902344 L9.09472656,8.74902344 Z M7.50292969,10.2626953 C7.50292969,10.5035819 7.59000564,10.7013339 7.76416016,10.855957 C7.93831467,11.0105802 8.15559766,11.0878906 8.41601562,11.0878906 C8.67643359,11.0878906 8.89371658,11.0105802 9.06787109,10.855957 C9.24202561,10.7013339 9.32910156,10.5035819 9.32910156,10.2626953 C9.32910156,10.0218087 9.24202561,9.82405676 9.06787109,9.66943359 C8.89371658,9.51481042 8.67643359,9.4375 8.41601562,9.4375 C8.15559766,9.4375 7.93831467,9.51481042 7.76416016,9.66943359 C7.59000564,9.82405676 7.50292969,10.0218087 7.50292969,10.2626953 Z'
                        id='Combined-Shape'></path>
                </g>
            </g>
        </g>
    </svg>;

const Success = () => 
    <svg data-cy='success-icon' width='14px' height='14px' viewBox='0 0 14 14' version='1.1' xmlns='http://www.w3.org/2000/svg' >
        <g id='ui-elements' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
            <g id='UI-elements' transform='translate(-598.000000, -3242.000000)'>
                <g id='OK' transform='translate(598.000000, 3242.000000)'>
                    <circle id='Oval' fill='#38D87D' cx='7' cy='7' r='7'></circle>
                    <path d='M5.30330086,6.80330086 L11.3033009,6.80330086 L11.3033009,8.80330086 L3.30330086,8.80330086 L3.30330086,6.80330086 L3.30330086,3.80330086 L5.30330086,3.80330086 L5.30330086,6.80330086 Z' id='Combined-Shape' fill='#FFFFFF' transform='translate(7.303301, 6.303301) rotate(-50.000000) translate(-7.303301, -6.303301) '></path>
                </g>
            </g>
        </g>
    </svg>;

const Error = () => 
    <svg data-cy='error-icon' width='14px' height='14px' viewBox='0 0 14 14' version='1.1'>
        <g id='ui-elements' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
            <g id='UI-elements' transform='translate(-598.000000, -3267.000000)'>
                <g id='disconected' transform='translate(598.000000, 3267.000000)'>
                    <circle id='Oval' fill='#DA2946' cx='7' cy='7' r='7'></circle>
                    <polygon id='Combined-Shape' fill='#FFFFFF' transform='translate(6.878680, 7.035534) rotate(-45.000000) translate(-6.878680, -7.035534) ' points='2.87867966 6.03553391 10.8786797 6.03553391 10.8786797 8.03553391 2.87867966 8.03553391'></polygon>
                    <polygon id='Combined-Shape-Copy' fill='#FFFFFF' transform='translate(6.878680, 7.035534) scale(-1, 1) rotate(-45.000000) translate(-6.878680, -7.035534) ' points='2.87867966 6.03553391 10.8786797 6.03553391 10.8786797 8.03553391 2.87867966 8.03553391'></polygon>
                </g>
            </g>
        </g>
    </svg>;

const TriangleOpen = () => 
    <svg width='7px' height='4px' viewBox='0 0 7 4' version='1.1'>
        <g id='ui-elements' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
            <g id='UI-elements' transform='translate(-636.000000, -3225.000000)' fill='#9290A4' fillRule='nonzero'>
                <polygon id='Triangle-open' 
                    transform='translate(639.500000, 3227.000000) scale(1, -1) translate(-639.500000, -3227.000000) ' 
                    points='642.262015 3229 643 3228.30346 639.5 3225 636 3228.30346 636.737985 3229 639.5 3226.39309'>
                </polygon>
            </g>
        </g>
    </svg>;

const TriangleClose = () => 
    <svg width='7px' height='4px' viewBox='0 0 7 4' version='1.1'>
        <g id='ui-elements' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
            <g id='UI-elements' transform='translate(-662.000000, -3225.000000)' fill='#9290A4' fill-rule='nonzero'>
                <polygon id='Triangle-close' 
                    points='668.262015 3229 669 3228.30346 665.5 3225 662 3228.30346 662.737985 3229 665.5 3226.39309'>
                </polygon>
            </g>
        </g>
    </svg>;

const Back = () => 
    <svg width='11px' height='10px' viewBox='0 0 11 10' version='1.1' 
            xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink'>
        <g id='Page-1' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
            <g id='Icons' transform='translate(-126.000000, -411.000000)' stroke='#444444'>
                <g id='back' transform='translate(127.000000, 411.000000)'>
                    <g id='Group-7'>
                        <polyline id='Path-5' points='4.52769257 0 0 4.52769257 4.80460488 9.33229745'></polyline>
                        <path d='M0.5,4.5 L9.5,4.5' id='Line-4' strokeLinecap='square'></path>
                    </g>
                </g>
            </g>
        </g>
    </svg>;

export {
    Alert,
    Success,
    Error,
    TriangleOpen,
    TriangleClose,
    Back
};


// WEBPACK FOOTER //
// ./src/components/common/icons/index.jsx